import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Section, Heading, FullwidthImage } from 'components';
import './Experts.scss';

const Experts = () => (
  <StaticQuery
    query={graphql`
      query {
        image: file(
          relativePath: { eq: "connect/our-experts-in-the-office.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1420) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Section additionalClass={'connect-page__experts'} spaceless>
        <FullwidthImage image={data.image.childImageSharp.fluid} />
        <div className={'connect-page__experts-box'}>
          <div className={'backdrop'} />
          <Heading type={3} color={'white'} size={'medium-plus'}>
            <span className={'connect-page__experts-number'}>130</span>
            <br />
            experts ready to answer your needs
          </Heading>
        </div>
      </Section>
    )}
  />
);

export default Experts;
